import { transparent } from "material-ui/styles/colors";

export const statisticsStyles = theme => ({
    outerContainer: {
        paddingTop: '4vh',
        display: 'flex',
        justifyContent: 'space-between',
        paddingRight: '2vw',
    },
    heading: {
        fontSize: '28px',
        fontWeight: 300,
        color: theme.palette.coolGray,
        paddingLeft: '3vw',
    },
    loading: {
        top: '40%',
        right: '45%',
        position: 'fixed'
    },
    innerContainer: {
        paddingLeft: '3vw',
        width: '100%',
        backgroundColor: theme.palette.dark,
        paddingBottom: '2vh'
    },
    subHeading:{
        fontSize: '16px',
        color: theme.palette.white,
        margin: '2vh 0vw'
    },
    usageCountDiv:{
        width: '190px',
        height: '99px',
        backgroundColor: theme.palette.newGray,
        padding: '17px',
        borderRadius: '7px',
        marginRight: '1vw',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    table:{
        width: '430px',
        backgroundColor: theme.palette.newGray,
        borderRadius: '7px',
    },
    agentTable:{
        width: '604px',
        backgroundColor: theme.palette.newGray,
        borderRadius: '7px',
    },
    tableHeader:{
        fontSize: '13px',
        color: theme.palette.steelGray2,
        border: 'none'
    },
    sortIcons:{
        marginLeft: '1vw'
    },
    tableData:{
        color: theme.palette.white,
        fontSize: '13px',
        borderColor: 'rgba(149,168,210, 0.12)',
    },
    button:{
        marginTop: '2vh',
        backgroundColor: 'transparent',
        color: 'white',
        marginRight: '1vw'
    }
})